import {FormApi as FinalFormApi} from 'final-form';

import {PossibleObject} from '../../../types/PossibleObject';
import {FieldName} from './FieldName';

/**
 * @deprecated - use platform Form instead
 */
export type FormApi<
  FormValues extends PossibleObject = undefined,
  InitialFormValues extends PossibleObject = undefined,
> = Omit<FinalFormApi<FormValues, InitialFormValues>, 'change'> & {
  change: (name: FieldName<FormValues, undefined>, value?: unknown) => void;
};
